import * as numberHelper from "common/utils/numberHelper";
export const getIfNeedsAgencyData = (urlOfficeId, report) => {
    // Only fetch data if we need to
    if (urlOfficeId) {
        if (!report || !report.reportData) {
            return true;
        }
        else {
            if (report.reportData.agencyId != urlOfficeId && !report.isFetching) {
                return true;
            }
        }
    }
    return false;
};
export const getIfNeedsOfficeData = (urlOfficeId, report) => {
    // Only fetch data if we need to
    if (urlOfficeId) {
        if (!report || !report.reportData) {
            return true;
        }
        else {
            if (report.reportData.officeId != urlOfficeId && !report.isFetching) {
                return true;
            }
        }
    }
    return false;
};
export const formatBigNumber = (value) => {
    return numberHelper.formatNumber(value);
};
